document.addEventListener('DOMContentLoaded', function () {
  function updateColorSwatches(container) {
    const variantsData = JSON.parse(container.querySelector('script[type="application/json"]').textContent);

    const primaryInput = container.querySelector('input:not([name="Color"]):checked');
    if (!primaryInput) return;
    const selectedPrimary = primaryInput.value;

    const colorItems = container.querySelectorAll('.swatch_color li');
    colorItems.forEach(li => {
      const label = li.querySelector('.single-color');
      if (!label) return;
      const colorValue = label.getAttribute('data-variant');

      // Check if this color exists for the selected primary option
      const availableFor = li.getAttribute('data-available-for') || '';
      const isAvailable = availableFor.split('|').includes(selectedPrimary);

      if (isAvailable) {
        li.style.display = '';

        // Update swatch image to match selected primary + color
        const matchingVariant = variantsData.find(v =>
          v.option1 === selectedPrimary && v.option2 === colorValue
        );
        if (matchingVariant && matchingVariant.featured_image) {
          const imgUrl = matchingVariant.featured_image.src.replace(/(\.[^.]+)$/i, '_small$1');
          let img = label.querySelector('img');
          if (img) {
            img.src = imgUrl;
            img.alt = matchingVariant.featured_image.alt || colorValue;
          }
        }
      } else {
        li.style.display = 'none';
      }
    });
  }

  document.querySelectorAll('variant-radios').forEach(container => {
    container.addEventListener('change', function (e) {
      if (e.target.name !== 'Color') {
        updateColorSwatches(container);
      }
    });
    updateColorSwatches(container);
  });
});
